<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner">
        <el-carousel
          indicator-position="none"
          arrow="always"
          style="width: 100%"
          :height="autoHeight"
        >
          <el-carousel-item v-for="(item, index) in picsArrImg" :key="index">
            <img
              :src="item.picturePath"
              style="width: 100%"
              @click="handleDetail(item)"
            />
          </el-carousel-item>
        </el-carousel>
        <div class="btn-more" @click="handleMore">
          <img src="../../assets/english/imgs/more@2x.png" />
        </div>
      </div>
      <div class="main2-content" id="more">
        <div style="height: 50px"></div>
        <div class="layout-title">
          <div class="title">Explore SAIC VOLKSWAGEN</div>
          <div class="line"></div>
        </div>
        <div class="layout-flex">
          <div
            class="layout-flex-item"
            v-for="(item, index) in selectList"
            :key="index"
            @click="handleDetail(item)"
          >
            <img :src="item.picturePath" style="width: 100%" />
            <div class="item-title">{{ item.title }}</div>
            <div class="item-intro" v-html="item.introduction"></div>
          </div>
        </div>
        <div style="height: 120px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
import { csvw_url } from "../../components/config";
export default {
  components: {},
  data() {
    return {
      autoHeight: "300px",
      picsArrImg: [],
      selectList: [],
    };
  },
  beforeMount() {
    let _w = document.documentElement.clientWidth || document.body.clientWidth;
    this.autoHeight = (_w * 950) / 1920 + "px";
  },
  mounted() {
    this.getImage();
    this.getList();
  },
  methods: {
    // 轮播图
    getImage() {
      // this.picsArrImg = [
      //   {
      //     picturePath: require("../../assets/english/imgs/1001.png")
      //   },
      //   {
      //     picturePath: require("../../assets/english/imgs/1001.png")
      //   }
      // ];

      this.picsArrImg = [];
      this.axios
        .get(`${csvw_url}/front/news/tcEngKv/list?type=130`)
        .then((res) => {
          console.log(res);
          let list = res.data.data;
          list.forEach((item) => {
            item.picturePath = `${csvw_url}${item.picturePath}`;
            item.mobilePicturePath = `${csvw_url}${item.mobilePicturePath}`;
          });
          this.picsArrImg = list;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    // 列表
    getList() {
      // this.selectList = [
      //   {
      //     picturePath: require("../../assets/english/imgs/1101.png"),
      //     title: "Enterprise overview",
      //     intro:
      //       "SAIC VOLKSWAGEN AUTOMOTIVE CO., LTD. (SAIC VOLKSWAGEN for short) is a Sino-German joint venture founded by SAIC Motor and Volkswagen Group in October 1984."
      //   },
      //   {
      //     picturePath: require("../../assets/english/imgs/1102.png"),
      //     title: "Plant layout",
      //     intro:
      //       "Headquartered in Anting, Shanghai, the company has established production bases in Nanjing, Yizheng, Urumqi, Ningbo, Changsha, etc."
      //   },
      //   {
      //     picturePath: require("../../assets/english/imgs/1103.png"),
      //     title: "Social Responsibility",
      //     intro:
      //       "SAIC Volkswagen fully integrates CSR work into the company's business management process, creates the social responsibility of the whole value chain, and realizes the value sharing between the enterprise and the society."
      //   }
      // ];

      this.selectList = [];
      this.axios
        .get(`${csvw_url}/front/news/tcEngHomePage/list`)
        .then((res) => {
          console.log(res);
          let list = res.data.data;
          list.forEach((item) => {
            item.picturePath = `${csvw_url}${item.picturePath}`;
            item.mobilePicturePath = `${csvw_url}${item.mobilePicturePath}`;
          });
          this.selectList = list;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    handleDetail(item) {
      console.log(item);
      // this.$router.replace({ name: "about_en", query: { index: index } });
      if (item.url) {
        window.open(item.url, "_self");
      }
    },
    handleMore() {
      document.querySelector("#more").scrollIntoView(true);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
  font-family: "Microsoft Yahei", "微软雅黑";
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #f5f5f5;
}

.main2-content {
  width: calc(100% - 60px);
  margin: 0px 30px;
}

.layout-flex {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-item {
    width: 380px;
    cursor: pointer;
  }
  .item-title {
    height: 40px;
    font-size: 22px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    margin-top: 10px;
  }
  .item-intro {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    /deep/p {
      margin: 0px;
    }
  }
}

.layout-title {
  .title {
    font-size: 28px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .line {
    width: 90px;
    height: 5px;
    background: #4697f2;
    margin: 20px auto 50px auto;
  }
}

.banner {
  position: relative;
  /deep/.el-carousel__arrow {
    font-size: 48px;
    height: 60px;
    width: 60px;
  }
}

.btn-more {
  position: absolute;
  bottom: 20px;
  z-index: 8;
  left: 47%;
  cursor: pointer;
  animation: godown 1s linear infinite;
}

/* @keyframes 浮动效果 */
@keyframes godown {
  0% {
    bottom: 20px;
  }

  50% {
    bottom: 30px;
  }

  100% {
    bottom: 20px;
  }
}

@media screen and (min-width: 1600px) {
  .main2-content {
    .layout-flex {
      width: 1600px;
      .layout-flex-item {
        width: 520px;
      }
    }
  }
}
</style>
